/**
 * kioskMode — leichte Tab-Sperre fuer TV-/Terminal-Geraete.
 *
 * Wenn eine TV- oder Terminal-Seite gemountet wird, hinterlegen wir den
 * eigenen Pfad in `sessionStorage` (gilt nur fuer den aktuellen Browser-Tab).
 * Catch-All-Routen und die Login-Seite pruefen diesen Wert: wenn gesetzt,
 * wird jede Fremd-URL zurueck auf die Kiosk-Seite geleitet, sodass Gaeste
 * am Geraet nicht aus Versehen oder neugierig die Login-Seite finden.
 *
 * Bewusst nicht in `localStorage`, damit Admins den Kiosk-Modus durch ein
 * einfaches Schliessen + Neuoeffnen des Tabs verlassen koennen.
 */

const KEY = 'kiosk_mode_path';

export function activateKioskMode(path) {
  try {
    window.sessionStorage.setItem(KEY, path);
  } catch {
    /* sessionStorage evtl. blockiert (z.B. Private-Mode) – kein Hard-Fail */
  }
}

export function getKioskPath() {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function isKioskMode() {
  return !!getKioskPath();
}

export function deactivateKioskMode() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
